import { FailedStatus } from './FailedStatus'

export default FailedStatus
